export enum GroupEmptyPlacementType {
  Top = 'top',
  Bottom = 'bottom',
}
